import ApiService from "app/services/ApiService";

export const GET_SIGNATURE_CONTRACTS_RQ = 'GET_SIGNATURE_CONTRACTS_RQ'
export const GET_SIGNATURE_CONTRACTS_SC = 'GET_SIGNATURE_CONTRACTS_SC'
export const GET_SIGNATURE_CONTRACTS_FL = 'GET_SIGNATURE_CONTRACTS_FL'

export const GET_SIGNATURE_CATEGORY_RQ = 'GET_SIGNATURE_CATEGORY_RQ'
export const GET_SIGNATURE_CATEGORY_SC = 'GET_SIGNATURE_CATEGORY_SC'
export const GET_SIGNATURE_CATEGORY_FL = 'GET_SIGNATURE_CATEGORY_FL'

export const INSUPD_SIGNATURE_RQ = 'INSUPD_SIGNATURE_RQ'
export const INSUPD_SIGNATURE_SC = 'INSUPD_SIGNATURE_SC'
export const INSUPD_SIGNATURE_FL = 'INSUPD_SIGNATURE_FL'

export const DEL_SIGNATURE_RQ = 'DEL_SIGNATURE_RQ'
export const DEL_SIGNATURE_SC = 'DEL_SIGNATURE_SC'
export const DEL_SIGNATURE_FL = 'DEL_SIGNATURE_FL'

export const FETCH_SIGNATURE_RQ = 'FETCH_SIGNATURE_RQ'
export const FETCH_SIGNATURE_SC = 'FETCH_SIGNATURE_SC'
export const FETCH_SIGNATURE_FL = 'FETCH_SIGNATURE_FL'


export const FILTER_SIGNATURE_RQ = 'FILTER_SIGNATURE_RQ'
export const FILTER_SIGNATURE_SC = 'FILTER_SIGNATURE_SC'
export const FILTER_SIGNATURE_FL = 'FILTER_SIGNATURE_FL'

export const CLEAR_REDUCER = 'CLEAR_REDUCER'

export const SAVE_PAGINATION = 'SAVE_PAGINATION';

export const cleanSignature = () => dispatch => {
    dispatch({ type: CLEAR_REDUCER });
}

export const getSignaturesFilters= (payload) => dispatch => {
    dispatch({ type: FILTER_SIGNATURE_RQ });
    ApiService.getSignatureFilters(payload).then(
        response => {
            dispatch({
                type: FILTER_SIGNATURE_SC,
                payload: response
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: FILTER_SIGNATURE_FL, payload: error });
        }
    )
}

export const getSignaturesContracs = () => dispatch => {
    dispatch({ type: GET_SIGNATURE_CONTRACTS_RQ });
    ApiService.getSignatureContract().then(
        response => {
            dispatch({
                type: GET_SIGNATURE_CONTRACTS_SC,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_SIGNATURE_CONTRACTS_FL, payload: error.response.message });
        }
    )
}

export const getSignaturesECategory = () => dispatch => {
    dispatch({ type: GET_SIGNATURE_CATEGORY_RQ });
    ApiService.getSignatureEmployeeCategory().then(
        response => {
            dispatch({
                type: GET_SIGNATURE_CATEGORY_SC,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: GET_SIGNATURE_CATEGORY_FL, payload: error.response.message });
        }
    )
}

export const postSignatory = (payload, callback) => dispatch => {
    dispatch({ type: INSUPD_SIGNATURE_RQ });
    ApiService.postUpdateSignature(payload).then(
        response => {
            dispatch({
                type: INSUPD_SIGNATURE_SC,
                payload: "El firmante se guardo correctamente"
            });

            if (typeof callback === 'function') {
                callback();
            }
        }
    ).catch(
        (error) => {
           dispatch({ type: INSUPD_SIGNATURE_FL, payload: error.response.data.message });
        }
    )
}

export const delSignature = (payload, callback) => dispatch => {
    dispatch({ type: DEL_SIGNATURE_RQ });
    ApiService.deleteSignature(payload).then(
        response => {
            dispatch({
                type: DEL_SIGNATURE_SC,
                payload: response.listData
            });

            if (typeof callback === 'function') {
                callback();
            }
        }
    ).catch(
        (error) => {
            dispatch({ type: DEL_SIGNATURE_FL, payload: error.response.message });
        }
    )
}

export const getListSignatures = (payload) => dispatch => {
    dispatch({ type: FETCH_SIGNATURE_RQ });
    ApiService.getSignatures(payload).then(
        response => {
            dispatch({
                type: FETCH_SIGNATURE_SC,
                payload: response.listData
            });
        }
    ).catch(
        (error) => {
            dispatch({ type: FETCH_SIGNATURE_FL, payload: error.response.message });
        }
    )
}

export const savePagination = (pagination) => ({
    type: SAVE_PAGINATION,
    payload: pagination
});